{
  "name": "daedalus-v2",
  "private": true,
  "version": "1.32.7",
  "type": "module",
  "scripts": {
    "dev": "vite --host --port 3001",
    "dev:mock": "cross-env VITE_USE_MOCK_DATA=true pnpm dev",
    "dev:demo": "cross-env VITE_DEMO=true pnpm dev",
    "dev:capture": "cross-env VITE_CAPTURE=true pnpm dev",
    "build": "tsc && vite build",
    "build:e2e": "vite build",
    "build:cicd": "env-cmd -f .env.cicd pnpm run build",
    "build:demo": "env-cmd -f .env.demo pnpm run build",
    "build:demo:deploy": "env-cmd -f .env.demo.deploy pnpm run build",
    "check": "concurrently -r \"pnpm check:types\" \"pnpm check:lint\" \"pnpm check:cycles\" \"pnpm check:ticket-refs\" \"pnpm --filter @bylt/e2e check\"",
    "check:types": "tsc --noEmit",
    "check:lint": "eslint ./src ./tools",
    "check:cycles": "madge --circular --extensions ts,tsx --ts-config tsconfig.json src tools",
    "check:ticket-refs": "node scripts/check-ticket-refs.js",
    "check:codegen": "node scripts/codegen-bql.js --check",
    "check:bundle": "node scripts/scan-bundle.js",
    "check:bundle:secrets": "node scripts/scan-bundle.js --secrets",
    "check:dead": "knip --production",
    "check:dead:all": "knip",
    "check:dup": "jscpd --threshold 3",
    "format": "prettier --write . --config .prettierrc",
    "format:single": "prettier --write --config .prettierrc",
    "terraform:build": "env-cmd -f .env.terraform pnpm run build",
    "terraform:format": "terraform fmt ./terraform",
    "analyze": "cross-env VITE_ANALYZE=true pnpm run build",
    "test": "vitest",
    "test:ci": "vitest run --reporter=github-actions --reporter=dot",
    "test:ui": "vitest --ui",
    "test:e2e": "pnpm --filter @bylt/e2e test",
    "test:demo": "pnpm --filter @bylt/e2e test:demo",
    "codegen:bql": "node scripts/codegen-bql.js",
    "bump": "node scripts/bump.js",
    "deploy": "node scripts/deploy.js",
    "prepare": "husky"
  },
  "dependencies": {
    "@ai-sdk/react": "^4.0.110",
    "@base-ui/react": "^1.8.0",
    "@clerk/react": "^6.16.1",
    "@date-fns/tz": "^1.5.0",
    "@daypicker/react": "10.0.1",
    "@dnd-kit/collision": "^0.5.0",
    "@dnd-kit/dom": "^0.5.0",
    "@dnd-kit/helpers": "^0.5.0",
    "@dnd-kit/react": "^0.5.0",
    "@fontsource-variable/jetbrains-mono": "^5.3.0",
    "@fontsource/poppins": "^5.3.0",
    "@maskito/core": "^5.4.0",
    "@maskito/kit": "^5.4.0",
    "@maskito/react": "^5.4.0",
    "@posthog/react": "^1.11.1",
    "@radix-ui/react-use-controllable-state": "^1.2.6",
    "@react-pdf/renderer": "^4.9.0",
    "@sentry/react": "^10.75.0",
    "@streamdown/cjk": "^1.0.3",
    "@streamdown/math": "^1.0.2",
    "@t3-oss/env-core": "^0.13.11",
    "@tanstack/query-async-storage-persister": "^5.103.1",
    "@tanstack/react-form": "^1.33.5",
    "@tanstack/react-query": "^5.103.1",
    "@tanstack/react-query-devtools": "^5.103.1",
    "@tanstack/react-query-persist-client": "^5.103.1",
    "@tanstack/react-router": "^1.170.38",
    "@tanstack/react-router-devtools": "^1.167.2",
    "@tanstack/react-table": "^8.21.3",
    "@tanstack/react-virtual": "^3.14.13",
    "@tanstack/zod-adapter": "^1.167.0",
    "@uidotdev/usehooks": "^2.4.1",
    "ai": "^7.0.107",
    "canvas-confetti": "^1.9.4",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "cmdk": "^1.1.1",
    "date-fns": "^4.4.0",
    "dompurify": "^3.4.15",
    "embla-carousel-react": "^8.6.0",
    "input-otp": "^1.5.0",
    "lucide-react": "^1.47.0",
    "motion": "^13.4.0",
    "posthog-js": "^1.434.2",
    "qrcode.react": "^4.2.0",
    "react": "19.3.0",
    "react-dom": "19.3.0",
    "react-dropzone": "^20.1.2",
    "react-fast-compare": "^3.2.2",
    "react-grid-layout": "^2.2.4",
    "react-joyride": "^3.2.0",
    "react-markdown": "^10.1.0",
    "react-querybuilder": "^8.24.0",
    "react-resizable-panels": "^4.12.4",
    "react-top-loading-bar": "^3.0.2",
    "recharts": "3.10.1",
    "shadcn": "^4.21.0",
    "sonner": "^2.0.8",
    "streamdown": "^2.6.0",
    "tailwind-merge": "^3.7.0",
    "tinyduration": "^3.4.1",
    "tw-animate-css": "^1.4.0",
    "use-stick-to-bottom": "^1.1.6",
    "vaul": "^1.1.2",
    "zod": "^4.6.5",
    "zustand": "^5.0.15"
  },
  "devDependencies": {
    "@babel/core": "^8.0.6",
    "@clerk/shared": "^4.33.0",
    "@eslint-react/eslint-plugin": "^5.20.2",
    "@eslint/js": "^10.0.1",
    "@faker-js/faker": "^10.6.0",
    "@ianvs/prettier-plugin-sort-imports": "^4.7.1",
    "@playwright/test": "^1.63.0",
    "@rolldown/plugin-babel": "^0.2.4",
    "@sentry/vite-plugin": "^5.4.0",
    "@svgr/plugin-jsx": "^8.1.0",
    "@svgr/plugin-svgo": "^8.1.0",
    "@tailwindcss/typography": "^0.5.20",
    "@tailwindcss/vite": "^4.3.3",
    "@tanstack/eslint-plugin-query": "^5.103.1",
    "@tanstack/eslint-plugin-router": "^1.162.0",
    "@tanstack/router-plugin": "^1.168.40",
    "@testing-library/dom": "^10.4.2",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/react": "^16.3.3",
    "@testing-library/user-event": "^14.6.7",
    "@types/babel__core": "^7.20.5",
    "@types/canvas-confetti": "^1.9.0",
    "@types/node": "^26.6.2",
    "@types/react": "^19.3.0",
    "@types/react-dom": "^19.3.0",
    "@vitejs/plugin-react": "^6.1.1",
    "@vitest/coverage-v8": "^5.0.1",
    "@vitest/ui": "^5.0.1",
    "babel-plugin-react-compiler": "^1.0.0",
    "browserslist": "^4.29.0",
    "concurrently": "^10.0.5",
    "cross-env": "catalog:",
    "env-cmd": "^11.0.0",
    "eslint": "^10.11.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.5",
    "eslint-plugin-boundaries": "^7.2.0",
    "eslint-plugin-react-hooks": "7.1.1",
    "husky": "^9.1.7",
    "jscpd": "^5.3.0",
    "jsdom": "^30.0.1",
    "knip": "^6.37.0",
    "lightningcss": "^1.33.0",
    "madge": "^8.0.0",
    "msw": "^2.15.0",
    "playwright": "^1.63.0",
    "prettier": "^3.9.8",
    "prettier-plugin-tailwindcss": "^0.8.1",
    "tailwindcss": "^4.3.3",
    "tsx": "^4.23.15",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.70.0",
    "vite": "^8.3.0",
    "vite-bundle-analyzer": "^1.3.9",
    "vite-plugin-svgr": "^5.2.0",
    "vitest": "^5.0.1"
  },
  "msw": {
    "workerDirectory": [
      "public"
    ]
  },
  "engines": {
    "node": ">=24.15",
    "pnpm": ">=12"
  },
  "packageManager": "pnpm@12.5.1"
}
